import React, { useEffect, useState, useRef } from 'react';

const createPopup = ({ url, title, height, width, }) => {
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;
    const externalPopup = window.open(
        url,
        title,
        `width=${width},height=${height},left=${left},top=${top}`,
    );
    return externalPopup;
};

const OauthPopup = ({
    title = '',
    width = 500,
    height = 500,
    url,
    children,
    onCode,
    onClose,
}) => {
    const [externalWindow, setExternalWindow] = useState();
    const intervalRef = useRef();

    const clearTimer = () => {
        window.clearInterval(intervalRef.current);
    };

    const onContainerClick = () => {
        setExternalWindow(createPopup({ url, title, width, height }));
    };

    useEffect(() => {
        if (externalWindow) {
            intervalRef.current = window.setInterval(() => {
                try {
                    const currentUrl = externalWindow.location.href;
                    const params = new URL(currentUrl).searchParams;
                    const code = params.get('code');
                    if (!code) {
                        //console.log('no code');
                        return;
                    }
                    onCode(code, params);
                    clearTimer();
                    externalWindow.close();
                    setExternalWindow(null);
                } catch (error) {
                    if (error.name === 'SecurityError') {
                        // we're still on rwgps.com, so we can't see the location.href yet, try again soon
                        return
                    }

                    console.error(error);
                    onClose();
                    clearTimer();
                    externalWindow.close();
                    setExternalWindow(null);
                } finally {
                    if (!externalWindow || externalWindow.closed) {
                        onClose();
                        clearTimer();
                        setExternalWindow(null);
                    }
                }
            }, 700);
        }
        return () => {
            if (externalWindow) {
                externalWindow.close();
                setExternalWindow(null);
            }
        };
    }, [externalWindow, onCode, onClose]);

    return (
        // eslint-disable-next-line
        <div
            onClick={() => {
                onContainerClick();
            }}
        >
            {children}
        </div>
    );
};

export default OauthPopup;